import { LegalDocumentsApiRoutes } from "../api";
export class LegalDocumentsApi {
    api;
    constructor(api) {
        this.api = api;
    }
    getDocumentsList() {
        return this.api.get(LegalDocumentsApiRoutes.GetLegalDocumentsList);
    }
}
